import React, { memo } from "react";
import { ObterRespostaGPT } from "../hooks/ObterRespostaGPT";
import { EmpreenderApps } from "../files/AppsArray";
import SuporteIcon from "../empreenderUI/ui/appsIcons/SuporteIcon";
import IndicadorCarregando from "./IndicadorCarregando";

interface MensagemProps {
  slugAtual: string;
}

// Faz a chamada à IA; a resposta é gravada no histórico e exibida pelo HistoricoConversas.
const ExibirRespostaGPT: React.FC<MensagemProps> = ({ slugAtual }) => {
  const dadosApp = EmpreenderApps.find(
    (item) => item.slug === slugAtual || item.sluges === slugAtual
  );

  const { loading } = ObterRespostaGPT({ slugAtual });

  return loading ? (
    <IndicadorCarregando
      icone={dadosApp?.icon || <SuporteIcon />}
      slugAmigavel={dadosApp?.slugamigavel}
      textoChave="procurando_artigos"
    />
  ) : null;
};

export default memo(ExibirRespostaGPT);
